import { render, staticRenderFns } from "./data-credits-dialog.vue?vue&type=template&id=48f464ef"
import script from "./data-credits-dialog.vue?vue&type=script&lang=js"
export * from "./data-credits-dialog.vue?vue&type=script&lang=js"
import style0 from "./data-credits-dialog.vue?vue&type=style&index=0&id=48f464ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports